import { useLocation } from 'react-router-dom';

import HorizontalDivider from '../components/common/HorizontalDivider';

// TODO: Update  support page link url
const NotFoundPage = () => {
  const location = useLocation();
  const message = location.state?.message ?? '';

  /*  Example redirect to this page

      onClick={() => {
        navigate('/not-found', {
          state: { message: 'We could not find your room' },
        });
      }}

  */

  return (
    <main className="flex justify-center gap-0">
      <section className="flex min-h-screen w-full flex-col gap-20 bg-white p-6 sm:p-12 md:p-12">
        <div className="flex flex-col gap-16">
          <div className="flex flex-col gap-4 pt-20 ">
            <div className="mx-auto text-9xl font-bold text-pj-primary-400 xxs:text-[12rem] md:text-[14rem]">
              <span className="relative -top-8 left-4">4</span>
              <span className="text-9xl  text-pj-primary-300 xxs:text-[10rem] md:text-[12rem]">
                0
              </span>
              <span className="relative -bottom-6 right-8">4</span>
            </div>
            <h1 className="mb-10 text-center text-4xl font-semibold text-pj-primary-400 xxs:text-5xl">
              Not Found
            </h1>
            <HorizontalDivider />
            <p className="mt-20 max-w-[500px] text-xl">
              {message.length
                ? message
                : ' We apologize, but the page you are looking for does not exist.'}
            </p>
          </div>
        </div>

        <p className="mt-auto text-center font-bold text-pj-gray-800">
          For further assistance, please contact the hotel reception.
        </p>
      </section>
    </main>
  );
};

export default NotFoundPage;
